import { CaseStatus } from '@debbie/common/dist/cases/index.js';
import { PermissionLevels } from '@debbie/common/dist/index.js';
import { TemplateGroupStates, TemplateState, TemplateType, } from '@debbie/common/dist/templates/index.js';
export const BASIC_THEME = {
    NAV_LEFT_WIDTH: 250,
    NAV_RIGHT_WIDTH: 300,
    NAV_TOP_HEIGHT: 60,
    SUB_MENU_HEIGHT: 60,
    COLOR_PRIMARY: '#200D54',
    COLOR_SECONDARY: '#FFFFFF',
    COLOR_ACCENT: '#7568F6',
    COLOR_GREY: '#8C8F98',
    BACKGROUND: '#F1F4FB',
    // Secondary text, at least 4.5:1 on white and BACKGROUND
    TEXT_MUTED: '#62656E',
    // Placeholders, disabled text and icons only, not body text
    TEXT_SUBTLE: '#8C8F98',
    // Translucent slate, so they read the same on white and BACKGROUND
    BORDER: 'rgba(40, 44, 56, 0.12)',
    BORDER_STRONG: 'rgba(40, 44, 56, 0.22)',
    SURFACE_INSET: 'rgba(40, 44, 56, 0.03)',
    SURFACE_MUTED: 'rgba(40, 44, 56, 0.06)',
    FILL: 'rgba(40, 44, 56, 0.1)',
    // Solid backgrounds under white text: badges, pills, avatars (4.6:1)
    NEUTRAL: '#72757E',
    // Translucent accent for hover, selected and focus states
    ACCENT_SURFACE: 'rgba(117, 104, 246, 0.08)',
    ACCENT_SURFACE_STRONG: 'rgba(117, 104, 246, 0.16)',
    ACCENT_BORDER: 'rgba(117, 104, 246, 0.35)',
    DANGEROUS: '#D7615C',
    WARNING: '#ffc107',
    SUCCESS: '#53BA41',
    DARK_COLOR_SECONDARY: '#8C8F98',
    STATUS_COLORS: {
        [CaseStatus.VERIFIED]: '#98D679',
        [CaseStatus.PENDING]: '#E5E56E',
        [CaseStatus.ENDED]: '#515D76',
    },
    STATE_COLORS: {
        [TemplateGroupStates.PUBLISHED_WIP]: '#515D76',
        [TemplateGroupStates.NEVER_PUBLISHED]: '#D07474',
        [TemplateGroupStates.WIP]: '#E5E56E',
        [TemplateState.DRAFT]: '#515D76',
        [TemplateState.PUBLISHED]: '#98D679',
        [TemplateState.VERSION]: '#E5E56E',
    },
    TYPE_COLORS: {
        [TemplateType.EMAIL]: '#ffc107',
        [TemplateType.LETTER]: '#08C',
        [TemplateType.SMS]: '#28a745',
        [TemplateType.AUTOCALL]: '#515D76',
        [TemplateType.EBOKS]: '#08C08C',
        [TemplateType.KIVRA]: '#0B7B7B',
        [TemplateType.DIGIPOST]: '#C8102E',
        [TemplateType.CREDITOR_MESSAGE]: '#9C6ADE',
        [TemplateType.DEBTOR_MESSAGE]: '#D07474',
        [TemplateType.NOTE]: '#6BA292',
    },
    USER_TYPE_COLORS: {
        [PermissionLevels.superAdmin]: '#D07474',
        [PermissionLevels.admin]: '#D07474',
        [PermissionLevels.caseworker]: '#ffc107',
        [PermissionLevels.client]: '#08C',
        [PermissionLevels.alternativeContact]: '#08C',
        [PermissionLevels.debtor]: '#08C',
    },
    MEDIA_QUERY_MOBILE: 'screen and (max-width: 770px)',
    MEDIA_QUERY_NOT_MOBILE: 'screen and (min-width: 771px)',
    MEDIA_QUERY_TABLET: 'screen and (max-width: 992px)',
    MEDIA_QUERY_NOT_TABLET: 'screen and (min-width: 993px)',
    GRID_SPACING: 20,
    DATE_FORMAT: 'Do MMMM YYYY',
    DATE_FORMAT_SHORT: 'DD.MM.YY',
    DATE_FORMAT_LONG: 'Do MMMM YYYY, H:mm:ss',
};
const THEME = JSON.parse(JSON.stringify(BASIC_THEME));
export default THEME;
export const updateTheme = (newTheme) => Object.entries({ ...BASIC_THEME, ...newTheme }).map((r) => {
    if (r[1]) {
        // @ts-ignore
        THEME[r[0]] = r[1];
    }
});
//# sourceMappingURL=theme.js.map